import NProgress from 'nprogress';

export const progressStart = (): void => {
    NProgress.start();
};

export const progressDone = (): void => {
    NProgress.done();
};
